import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Copy, ExternalLink, Save } from "lucide-react";
import { tokenStore } from "@/lib/api";

export const Route = createFileRoute("/_app/configuracion-pedidos")({ component: Settings });
const apiBase = import.meta.env.VITE_API_URL ?? "/api";

function Settings() {
  const [whatsapp, setWhatsapp] = useState("");
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const url = `${window.location.origin}/ordenar`;

  useEffect(() => {
    fetch(`${apiBase}/configuracion-pedidos`, { headers: { Authorization: `Bearer ${tokenStore.get() ?? ""}` } })
      .then(async (r) => { if (!r.ok) throw new Error(); return r.json(); })
      .then((result) => { setWhatsapp(result.data.whatsapp); setEnabled(result.data.habilitado); })
      .catch(() => setError("No se pudo cargar la configuración."))
      .finally(() => setLoading(false));
  }, []);

  async function save() {
    setSaving(true); setError(""); setMessage("");
    try {
      const response = await fetch(`${apiBase}/configuracion-pedidos`, {
        method: "PUT", credentials: "include",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${tokenStore.get() ?? ""}` },
        body: JSON.stringify({ whatsapp, habilitado: enabled }),
      });
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.error ?? "No se pudo guardar.");
      setWhatsapp(result.data.whatsapp);
      setMessage("Configuración guardada. Los cambios ya están disponibles en el formulario.");
    } catch (e) { setError(e instanceof Error ? e.message : "Error al guardar."); }
    finally { setSaving(false); }
  }

  return <main className="mx-auto max-w-3xl space-y-6 p-6">
    <div><h1 className="text-2xl font-extrabold">Pedidos en línea</h1>
      <p className="text-sm text-muted-foreground">Configura el formulario público de Cold Crew.</p></div>
    <section className="space-y-5 rounded-2xl border bg-white p-6">
      <div><label htmlFor="whatsapp" className="mb-2 block text-sm font-bold">WhatsApp para recibir pedidos</label>
        <input id="whatsapp" value={whatsapp} disabled={loading} onChange={e => setWhatsapp(e.target.value)}
          placeholder="Ej. 526121234567" inputMode="tel"
          className="w-full rounded-xl border bg-[#FAF9F6] px-4 py-3 outline-none focus:border-[#FF6500]" />
        <p className="mt-2 text-xs text-muted-foreground">Código de país y número, sin + ni espacios.</p></div>
      <label className="flex items-center justify-between gap-4 rounded-xl border p-4">
        <span><strong className="block text-sm">Aceptar pedidos en línea</strong>
          <span className="text-xs text-muted-foreground">Puedes desactivar temporalmente el envío por WhatsApp.</span></span>
        <input type="checkbox" checked={enabled} disabled={loading} onChange={e => setEnabled(e.target.checked)} className="h-5 w-5 accent-[#FF6500]" />
      </label>
      <div><label className="mb-2 block text-sm font-bold">Enlace para Instagram</label>
        <div className="flex gap-2"><input readOnly value={url} className="min-w-0 flex-1 rounded-xl border bg-[#FAF9F6] px-3 py-3 text-sm" />
          <button type="button" title="Copiar enlace" onClick={() => navigator.clipboard.writeText(url)} className="rounded-xl border p-3"><Copy size={18}/></button>
          <a href={url} target="_blank" rel="noreferrer" title="Abrir formulario" className="rounded-xl border p-3"><ExternalLink size={18}/></a></div></div>
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      {message && <p role="status" className="text-sm text-green-700">{message}</p>}
      <button onClick={save} disabled={saving || loading} className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#FF6500] px-5 py-3 font-bold text-black disabled:opacity-50">
        <Save size={18}/>{saving ? "Guardando..." : "Guardar cambios"}</button>
    </section>
  </main>;
}
